import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { cn } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { useNewBookingPath } from '../../hooks/useNewBookingPath';
import { useClearBookingDrafts } from '../../hooks/useStartNewBooking';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { BrandImage } from '../Brand/BrandImage';

export const BrandImageCard = ({ customText }: { customText?: string }) => {
  const clearBookingDrafts = useClearBookingDrafts();
  const { currentBrand } = useCurrentBrand();
  const { path: newBookingPath, isMobileOnly } = useNewBookingPath();

  return (
    <NoddiBasicCard
      onClick={clearBookingDrafts}
      to={newBookingPath}
      className={cn('flex flex-1 flex-col gap-3 overflow-hidden p-0')}
    >
      <BrandImage brand={currentBrand} />

      {/* If the current brand doesn't have a specific image,
    we add padding to the top of the card 
      */}
      <div className={cn('flex flex-col gap-3 px-5 pb-4', currentBrand === 'elitebilvask' && 'pt-4')}>
        <p>
          {customText ||
            (isMobileOnly
              ? t`We come to you — book a home delivery tire change`
              : t`Choose if you want to visit us or if we should come to you`)}
        </p>
        <NoddiDummyButton endIcon='ArrowRight' className='w-full'>
          <Trans>New booking</Trans>
        </NoddiDummyButton>
      </div>
    </NoddiBasicCard>
  );
};
